import { render, staticRenderFns } from "./ShNumber.vue?vue&type=template&id=e200728a&"
import script from "./ShNumber.vue?vue&type=script&lang=js&"
export * from "./ShNumber.vue?vue&type=script&lang=js&"
import style0 from "./ShNumber.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports